module.exports = function getResource(label, vars = []) {
    let resources = {
        title: 'Profitez au maximum de votre adhésion',
        tapBelowToExplore: 'Cliquez ci-dessous pour explorer nos articles en magasin',
        clickBelowToExplore: 'Cliquez ci-dessous pour explorer le magasin',
        achievementUnlocked: 'Niveau débloqué!',
        superFan: 'Vous êtes accro à Sephora',
        tapBelowToSee: 'Touchez ci-dessous pour découvrir d’autres façons de mettre votre beauté en valeur avec nous.',
        clickBelowToSee: 'Cliquez ci-dessous pour découvrir d’autres façons de mettre votre beauté en valeur avec nous.',
        community: 'Collectivité',
        takingAdvantageOfPerk: 'Vous profitez de cet avantage.',
        exploreNow: 'Découvrir',
        getInspo: 'Trouvez des inspirations, des conseils et des recommandations parmi les membres.',
        joinCommunity: 'Rejoignez la communauté',
        seeMonth: 'Consultez les',
        openApp: 'Ouvrez l’appli Sephora',
        shopOnTheGo: 'Magasinez à tout moment, bénéficiez de l’accès anticipé aux nouveautés, et plus encore.',
        ccMember: 'Vous êtes titulaire d’une carte de crédit Sephora! Continuez à magasiner et obtenez une remise de 4 % en récompense Carte de crédit Sephora.',
        getCC: 'Obtenez 15 % de remise sur votre premier achat lors de l’ouverture de session et l’utilisation de votre carte de crédit Sephora.',
        seeRewards: 'Voir vos récompenses',
        applyNow: 'S’inscrire',
        app: 'Application',
        sephoraCC: 'Carte de crédit SEPHORA',
        youAreOnIt: 'Vous y êtes!'
    };

    return resources[label];
};
